import { SeriesSerializersBookSeriesByline } from "types/serializers";

export default function BookSeriesPosition({ bookSeries }: { bookSeries: SeriesSerializersBookSeriesByline }) {
  if(!bookSeries.position) {
    return <>{bookSeries.details}</>;
  }
  return <>#{bookSeries.position}</>;
}
